import Pagination from '@/util/pagination'
import { formatDate } from '@/util/helpers'

export default function () {
  return {
    formatDate,
    messages: [],
    pagination: new Pagination(),
  }
}
